export const useScrollToError = () => {
    const errors = Array.from(document.querySelectorAll('.is-invalid')).filter(error => {
        return error.offsetParent !== null; // Filter for visible errors
    });

    if (errors.length > 0) {
        console.log("Scrolling to error:", errors[0]);
        errors[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

};